import React from 'react';
import { Payment } from '../../../../../core-module/services/payments/types';
import {getCalculationFromPaymentLine, getLabelsFromPaymentLine} from '../helpers';
import { PaymentDetailsFooterComponent } from './PaymentDetailsFooterComponent';
import { PaymentDetailsHeaderComponent } from './PaymentDetailsHeaderComponent';
import { PaymentLineComponent } from './PaymentLineComponent';
import { PaymentLineGroupComponent } from './PaymentLineGroupComponent';

interface Props {
  payment: Payment;
}

const PaymentsContainerDetails: React.FC<Props> = ({ payment }) => {
  const fullName = `${payment.firstName} ${payment.insertions || ''} ${payment.lastName}`;

  return (
    <div>
      <PaymentDetailsHeaderComponent
        name={fullName}
        paymentName={payment.driverPayoutMethod.displayName}
      />

      {payment.paymentLineGroups.map((group, index) => (
        <PaymentLineGroupComponent key={index} paymentLineGroup={group} />
      ))}

      <div style={{ marginBottom: 10 }}>
        {payment.paymentLinesWithoutGroup.map((line, index) => (
          <PaymentLineComponent
            key={index}
            name={line.displayName}
            labels={getLabelsFromPaymentLine(line)}
            calculation={getCalculationFromPaymentLine(line)}
          />
        ))}
      </div>

      <PaymentDetailsFooterComponent totalAmount={payment.totalAmount} />

      {(payment.paymentLineGroupsRemaining.length > 0 ||
        payment.paymentLineWithoutGroupRemaining.length > 0) && (
        <>
          <hr style={{ marginTop: 35, marginBottom: 35 }} />

          <h4>Overige routes</h4>

          {payment.paymentLineGroupsRemaining.map((group, index) => (
            <PaymentLineGroupComponent key={index} paymentLineGroup={group} />
          ))}

          <div style={{ marginBottom: 10 }}>
            {payment.paymentLineWithoutGroupRemaining.map((line, index) => (
              <PaymentLineComponent
                key={index}
                name={line.displayName}
                labels={getLabelsFromPaymentLine(line)}
                calculation={getCalculationFromPaymentLine(line)}
              />
            ))}
          </div>

          <PaymentDetailsFooterComponent name='Overig' totalAmount={payment.totalAmountRemaining} />
        </>
      )}
    </div>
  );
};

export { PaymentsContainerDetails };
